/**
 * Remove atributos `style` inline de HTML vindo do CMS antes de
 * renderizar via `dangerouslySetInnerHTML` — protege contra estilo
 * colado do Word/Google Docs (cor/tamanho de fonte fora do design
 * system, às vezes com contraste insuficiente) sobrevivendo pro DOM.
 * Não é sanitização de XSS (conteúdo já vem de editores de CMS
 * confiáveis) — só remove `style="..."`.
 */
export function stripInlineStyles(html: string): string {
  return html.replace(/\sstyle="[^"]*"/gi, "");
}
